import axios from "axios";
import Axios from 'services/BackendApi/BackendApi';
import ApiURLs from "services/BackendApi/BackendApiURLs";

import {
	SEARCH_REQUEST,
	SEARCH_SUCCESS,
	SEARCH_FAIL,
	CLEAN_SEARCH,
} from 'constants/searchConstants';

const queryResponse = {
    success: "false",
    result_header: {},
    records: [],
  };

export async function searchService(urlQuery) {
  const bearer = localStorage.getItem("userInfo");
  const token = JSON.parse(bearer).access_token;
  try {
    const query = ApiURLs.publicFilesURL+`search/query${urlQuery}`;
    const rest = await axios.get(query,{ headers: {"Authorization" : `Bearer ${token}`} });
    console.log(rest)
      if (rest.status !== 200) {
        return queryResponse;
      }
      if (rest.data.success !== "true") {
        return queryResponse;
      }
      
      return rest.data;
    } catch (error) {
      console.log(error);
      return queryResponse;
    }
  }

  // export const searchService = (params) => async (dispatch) => {
  //   dispatch({ type: SEARCH_REQUEST });
  //   try {
  //     const { data } = await Axios.SimpleSearch({ params });
  //     data?.success === 'true'
  //       ? dispatch({
  //           type: SEARCH_SUCCESS,
  //           payload: {
  //             result_header: data?.result_header,
  //             records: data?.records?.record,
  //           },
  //         })
  //       : dispatch({
  //           type: SEARCH_FAIL,
  //           error: 'Problema al realizar la búsqueda, inténtelo mas tarde',
  //         });
  //   } catch (error) {
  //     dispatch({
  //       type: SEARCH_FAIL,
  //       payload:
  //         error.response && error.response.data.message
  //           ? error.response.data.message
  //           : error.message,
  //     });
  //   }
  // };